























/* General */
import Vue from 'vue'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */

/* API */

export default Vue.extend({
  name: 'IfpFilterLastUpdatedWithinDays',

  props: {
    lastUpdatedWithinDays: {
      type: Number,
      default: null,
    },
  },

  data() {
    return {
      withinOptions: [
        {
          label: 'Last day',
          value: 1,
        },
        {
          label: 'Last 2 days',
          value: 2,
        },
        {
          label: 'Last week',
          value: 7,
        },
        {
          label: 'Last 2 weeks',
          value: 14,
        },
        {
          label: 'Last month',
          value: 30,
        },
      ],
    }
  },

  computed: {
    selectedWithinLabel(): string {
      const selected = this.withinOptions.find(
        w => w.value === this.lastUpdatedWithinDays,
      )

      if (selected) {
        return selected.label
      }

      // You can also hand-set the value to anything (180 is max on backend)
      return Math.min(this.lastUpdatedWithinDays, 180) + ' days'
    },
  },

  methods: {
    handleSelectedWithin(value: number) {
      this.$emit('last-updated-within-days-updated', value)
      // @ts-ignore
      this.$refs.dropdownRef.handleClose()
    },
    handleCloseClick() {
      this.handleSelectedWithin(null)
    },
  },
})
